<template>
  <div class="main-container dark bg-with-image h-100">
    <app-header />
    <div class="container h-100">
      <div class="card mx-5 h-100 d-flex flex-column align-items-center justify-content-center">
        <h1 class="page-title mb-2">
          Página não encontrada
        </h1>
        <span class="text-center mb-4">Não foi possível encontrar o recurso solicitado</span>
        <button
          class="btn btn-orange col-auto mx-1"
          @click.prevent="goBack"
        >
          Retornar ao sistema
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as sharedTypes from '../../shared/store/types'
import AppHeader from '../components/AppHeader'
export default {
  components: {
    AppHeader
  },
  mounted() {
    this.setNoOptionsHeaderType();
  },
  methods: {
    ...mapActions({
      setNoOptionsHeaderType: sharedTypes.SET_NO_OPTIONS_HEADER_TYPE,
    }),
    goBack() {
      window.location.href = process.env.VUE_APP_URL
    }
  }
}
</script>
